import PropTypes from "prop-types";
import React from "react";

export default function Alert({ type, message, disableCloseBtn = true } = {}) {
  // if (!message || !type) return <></>;
  const capitalize = (word) => {
    const lower = word.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };
  return (
    // <div
    // style={{ height: "50px" }}
    // >
    // {
    message && (
      <div
        className={`alert alert-${type} alert-dismissible fade show d-flex flex-row justify-content-between`}
        role="alert"
      >
        <div className="d-flex flex-row justify-content-start">
          <strong className="me-2">{capitalize(type)}</strong> {message}
        </div>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
          style={{ display: disableCloseBtn ? "none" : "block" }}
        ></button>
      </div>
    )
    // }
    // </div>
  );
}

Alert.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
  disableCloseBtn: PropTypes.bool,
};
